import React from "react";
import {
  Navigate,
  Outlet,
  createBrowserRouter,
} from "react-router-dom";
import Login from "./pages/Login";
import "react-toastify/dist/ReactToastify.css";
import Homepage from "./pages/Homepage";
import SubadminAccess from "./pages/SubadminAccess";
import Kyc from "./pages/Kyc";
import Footer from "./Components/Footer";
import AddSubAdmin from "./pages/AddSubAdmin";
import Subadmin from "./pages/Subadmin";
import ErrorPage from "./pages/ErrorPage";
import { jwtDecode } from "jwt-decode";
import OrdersHistory from "./pages/OrdersHistory";
import EditSubadmin from "./pages/EditSubadmin";
import ScrollToTop from "./Components/ScrollToTop";
import Settings from "./pages/Settings";
import Transction from "./pages/Transction";
import Singletransction from "./pages/Singletransction";
import RoiHistory from "./pages/RoiHistory";
import Referal from "./pages/Referal";
import ReportTrans from "./pages/ReportTrans";

const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  if (token === null || token === undefined) {
    console.log("tokentundefinedoken", token);
    return false;
  } else {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp > currentTime;
  }
};

const isAdmin = () => {
  const role = localStorage.getItem("role");
  return role === "admin";
};

const ProtectedRoute = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to={"/login"} />;
};

const AdminRoute = () => {
  return isAdmin() ? <Outlet /> : <Navigate to={"/"} />;
};

const App = () => {
  return (
    <>
    <ScrollToTop/>
      <Outlet />
      <Footer />
    </>
  );
};

export const router = createBrowserRouter([
  {
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Homepage />,
      },
      {
        element: <AdminRoute />,
        children: [
          {
            path: "/subadmin-access",
            element: <SubadminAccess />,
          },
          {
            path: "/subadmin",
            element: <Subadmin />,
          },
          {
            path: "/subadmin/add-new",
            element: <AddSubAdmin />,
          },
          {
            path: "/subadmin/:id",
            element: <EditSubadmin />,
          },
        ]
      },
      {
        path: "/user/:id",
        element: <Kyc />,
      },
      {
        path: "/order-history",
        element: <OrdersHistory />,
      },
      {
        path: "/transaction",
        element: <Transction />,
      },
      {
        path: "/transaction/:id",
        element: <Singletransction />,
      },
      {
        path: "/settings",
        element: <Settings />,
      },
      {
        path: "/roi_history",
        element: <RoiHistory />,
      },
      {
        path: "/referal",
        element: <Referal />,
      },
      {
        path: "/report-trans",
        element: <ReportTrans />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);
